// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".variable-pricing .expand-button .icon {\n  transition: transform 0.2s ease;\n}\n.variable-pricing .expanded .icon {\n  transform: rotate(180deg);\n}\n", ""]);
// Exports
module.exports = exports;
